import { Component, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { BaseCtl } from '@ncs/ncs-lib';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { EventService } from '@ncs/ncs-lib';
import { Subscription } from 'rxjs';
import {
  ActivatedRoute,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  Router,
} from '@angular/router';
import { SharedataService } from './common/service/sharedata.service';
import { SidebarEvent } from './SidebarEvent';
import { _adapters } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent extends BaseCtl {
  public ctxPath: string = 'NoPath';
  public userContext: any = null;
  currentLang: string = 'en';
  menulist: any = [];
  reportlist: any = [];
  urlList: any = [];
  inputsearchcontant: string = '';
  public accessList: any[] = [];
  currentYear: number = new Date().getFullYear();

  //Change menu event
  public eventChangeMenu: Subscription = Subscription.EMPTY;

  public eventSessionExpired: Subscription = Subscription.EMPTY;

  //Refresh broswer
  public 'eventRefresh': Subscription;

  public previousUrl = '';

  isSidebarCollapsed: boolean = false;

  public keySuffixContext: any;
  public sidebar: any;
  public userRole: any | undefined | null;
  public applicationId: any;
  public applicationRoleId: any;

  constructor(
    public override locator: ServiceLocatorService,
    public eService: EventService,
    public override route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private sharedata: SharedataService,
    private translate: TranslateService,
  ) {
    super('', locator, route);
    const savedLang = localStorage.getItem('userLanguage') || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(savedLang);
    this.currentLang = savedLang;
    var _self = this;

    _self.sharedata.setFunction('toggle', this.toggleDarkMode);
// In constructor, BEFORE the async block:
const storedKeySuffix = localStorage.getItem('keySuffix');
if (storedKeySuffix) {
  this.keySuffixContext = storedKeySuffix ;
  // ✅ Load userContext SYNCHRONOUSLY so template renders correctly on first paint
  const uc = localStorage.getItem(this.keySuffixContext + 'userContext');
  if (uc) {
    try {
      this.userContext = JSON.parse(uc);
    } catch (e) {
      this.userContext = null;
    }
  }
}

// Then the async block still runs to confirm/update it:
_self.locator.config.getProperty('endpoint.auth').then((property: string) => {
  _self.initApiEndpoint(property);
  _self.keySuffixContext = _self.locator.config.get('CONTEXT_PATH') + '-'; // overwrites
        this.subscribeToData();
      });
    _self.sidebar = new SidebarEvent();
  }
  public menuItems: any = [];

  // Toggle dropdown for menu item
  toggleDropdown(menu: any) {
    menu.isDropdownOpen = !menu.isDropdownOpen;
  }

  // Toggle dropdown for menu item
  toggleRoleDropdown(menu: any) {
    menu.isDropdownOpen = !menu.isDropdownOpen;
  }

  //Subscribe to error event
  override ngOnInit() {
    let _self = this;

    _self.profileName();
    _self.updateProfile();
    // Menu
    _self.form['roleId'] = 0;

    //event when menu changed
    _self.eventChangeMenu = this.eService.changeMenu.subscribe((text) => {
      _self.userContext = _self.locator.userContext;
      _self.menuItems = [];
      _self.isLoggingOut = false;

      const keySuffix = localStorage.getItem('keySuffix') || '';
      const storedTheme = localStorage.getItem(keySuffix + 'theme');
      _self.isTheme = storedTheme || 'lightmode';
      if (!storedTheme) {
        // No theme in storage = fresh login, force light
        document.documentElement.setAttribute('class', 'light-theme');
        document.documentElement.style.setProperty('--primary-color', '#fff');
        document.documentElement.style.setProperty(
          '--secondary-color',
          '#5f5f5f',
        );
      }

      let appId = localStorage.getItem(_self.keySuffixContext + 'appId');
      this.applicationId = appId;
      this.applicationRoleId = localStorage.getItem(
        _self.keySuffixContext + 'roleId',
      );

      // Get stored access list from localStorage
      const storedAccess = localStorage.getItem(
        _self.keySuffixContext + 'accessList',
      );
      if (storedAccess) {
        _self.accessList = JSON.parse(storedAccess);
      }

      _self.getApplicationDetails(appId);
      _self.getMenu(appId);
      _self.getApplicationRoles();
    });

    //session expired event
    _self.eventSessionExpired = this.eService.sessionExpired.subscribe(
      (text) => {
        _self.menuItems = [];
        _self.userContext = '';
        _self.accessList = []; // Clear access list on session expired
        localStorage.removeItem(_self.keySuffixContext + 'userContext');
        localStorage.removeItem(_self.keySuffixContext + 'accessList');
        //   this.eService.menuChanged("");
        this.locator.forward('login/session');
      },
    );

    //Browser refresh event
    _self.eventRefresh = _self.locator.router.events.subscribe((event: any) => {
      this.sharedata.changeTheme();
      this.sidebar.initializeSidebar();

      // ✅ LOADER LOGIC
      if (event instanceof NavigationStart) {
        const keySuffix = localStorage.getItem('keySuffix') || '';
        const isLoggedIn = !!localStorage.getItem(keySuffix + 'userContext');
        const isAuthUrl = [
          '/login',
          '/signup',
          '/forgotpassword',
          '/signupInvitation',
        ].some((path) => event.url.includes(path));
        // const isDashboard = event.url.includes('/dashboard');
        const isDashboard = event.url === '/dashboard' || event.url.startsWith('/dashboard?');

        // Case 1: Browser refresh while logged in
        const isRefresh =
          event.id === 1 && !_self.isLoggingOut && isLoggedIn && !isAuthUrl;

        // Case 2: First landing on dashboard after login
        const isFirstDashboard =
          isDashboard &&
          !_self.isLoggingOut &&
          isLoggedIn &&
          !(_self as any)._dashboardLoaded;

        if (isRefresh || isFirstDashboard) {
          if (isFirstDashboard) {
            (_self as any)._dashboardLoaded = true;
          }

          _self.isPageLoading = true;
          _self.loadingMessage = 'Loading';
          (_self as any)._loaderStartTime = Date.now();

          const messageInterval = setInterval(() => {
            if (!_self.isPageLoading) return;
            if (_self.loadingMessage === 'Loading') {
              _self.loadingMessage = 'Initializing';
            } else if (_self.loadingMessage === 'Initializing') {
              _self.loadingMessage = 'Processing';
            } else if (_self.loadingMessage === 'Processing') {
              _self.loadingMessage = 'Finalizing';
            }
          }, 800);

          (_self as any)._messageInterval = messageInterval;
        }
      }

      // ✅ HIDE LOADER — only if it was shown
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        if (_self.isPageLoading) {
          const navEndTime = Date.now();
          const startTime = (_self as any)._loaderStartTime ?? navEndTime;
          const elapsed = navEndTime - startTime;
          const minDisplay = 2000;
          const remaining = Math.max(0, minDisplay - elapsed);

          setTimeout(() => {
            if ((_self as any)._messageInterval) {
              clearInterval((_self as any)._messageInterval);
              (_self as any)._messageInterval = null;
            }
            _self.isPageLoading = false;
            _self.loadingMessage = 'Loading';
            (_self as any)._loaderStartTime = null;
          }, remaining);
        }
      }

      // ✅ YOUR EXISTING CODE — unchanged
      if (event instanceof NavigationStart) {
        const isAuthPage = [
          '/login',
          '/signup',
          '/forgotpassword',
          '/signupInvitation',
        ].some((path) => event.url.includes(path));

        if (isAuthPage) {
          document.documentElement.setAttribute('class', '');
          document.documentElement.style.removeProperty('--primary-color');
          document.documentElement.style.removeProperty('--secondary-color');
        }

        if (_self.menuItems.length === 0) {
          _self.locator.config
            .getProperty('CONTEXT_PATH')
            .then((property: string) => {
              _self.keySuffixContext = property + '-';
              const uc: string | null = localStorage.getItem(
                _self.keySuffixContext + 'userContext',
              );

              const storedUserRole = localStorage.getItem(
                _self.keySuffixContext + 'userRole',
              );
              if (storedUserRole) {
                _self.userRole = storedUserRole;
              }

              const storedAccess = localStorage.getItem(
                _self.keySuffixContext + 'accessList',
              );
              if (storedAccess) {
                _self.accessList = JSON.parse(storedAccess);
                console.log(
                  'Restored accessList on refresh:',
                  _self.accessList,
                );
              }

              if (uc !== null) {
                _self.userContext = JSON.parse(uc);
              } else {
                _self.locator.userContext = null;
              }

              if (_self.userContext) {
                const appId = localStorage.getItem(
                  _self.keySuffixContext + 'appId',
                );
                const roleId = localStorage.getItem(
                  _self.keySuffixContext + 'roleId',
                );
                _self.applicationRoleId = roleId;

                _self.getApplicationDetails(appId);

                if (roleId) {
                  _self.getApplicationRoles();
                }

                const menuItemsString = localStorage.getItem(
                  _self.keySuffixContext + 'menuItems',
                );

                _self.menuItems = menuItemsString
                  ? JSON.parse(menuItemsString)
                  : [];

                _self.getMenuReportAndUrl(_self.menuItems);

                _self.menulist = [
                  ..._self.menuData?.map((item: any) => ({
                    title: item.name,
                    Id: item.formId,
                  })),
                ];

                _self.reportlist = [
                  ..._self.reportData?.map((item: any) => ({
                    title: item.name,
                    Id: item.reportsId,
                  })),
                ];
              }

              _self.urlList = [
                ..._self.urlData?.map((item: any) => ({
                  title: item.name,
                  Id: item.url,
                })),
              ];
            });
        }
        this.previousUrl = this.locator.router.url;
      }
    });
  }

  public logout() {
    let _self = this;
    let url = _self.locator.config.get('endpoint.login') + '/logout';
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form.error = !res.success;
      _self.form.message = res.message;

      if (res.success) {
        _self.isLoggingOut = true;
        _self.isPageLoading = false;
        localStorage.clear();
        _self.isTheme = 'lightmode'; // ← already there
        document.documentElement.setAttribute('class', 'light-theme'); // ← already there
        document.documentElement.style.setProperty('--primary-color', '#fff');
        document.documentElement.style.setProperty(
          '--secondary-color',
          '#5f5f5f',
        );
        _self.forward('/login');
      }
    });
  }

  public getLocalStorateData(key: string): any {
    let obj: any = localStorage.getItem('user');
    return obj;
  }

  public getLocalStorageData(key: string): any {
    const storedData = localStorage.getItem(key);
    if (storedData) {
      try {
        return JSON.parse(storedData);
      } catch (error) {
        console.error('Error parsing localStorage data', error);
        return null;
      }
    }
    return null;
  }

  getMenu(id: any, callback?: any) {
    var _self = this;
    // _self.locator.router.navigateByUrl('/dashboard');
    let keySuffix = localStorage.getItem('keySuffix');
    let roleId = localStorage.getItem(keySuffix + 'roleId');
    let url =
      _self.locator.config.get('endpoint.application.role') +
      '/get/' +
      Number(roleId);

    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }

      _self.form.error = !res.success;
      _self.form.message = res.result.message;
      if (res.success) {
        _self.form.data.id = id;
        _self.userRole = res.result.data['name'];

        //  stores the userRole in localStorage
        localStorage.setItem(keySuffix + 'userRole', _self.userRole);

        _self.getMenuReportAndUrl(res.result.data.menus);

        if (_self.menuItems.length === 0) {
          _self.menuItems = res.result.data.menus;
          localStorage.setItem(
            keySuffix + 'menuItems',
            JSON.stringify(_self.menuItems),
          );
        }

        _self.menulist = [
          ..._self.menuData?.map((item: any) => ({
            title: item.name,
            Id: item.formId,
          })),
        ];

        _self.reportlist = [
          ..._self.reportData?.map((item: any) => ({
            title: item.name,
            Id: item.reportsId,
          })),
        ];

        _self.urlList = [
          ..._self.urlData?.map((item: any) => ({
            title: item.name,
            Id: item.url,
          })),
        ];
        let userContextStr =
          localStorage.getItem(keySuffix + 'userContext') ?? '{}';
        try {
          let userContext = JSON.parse(userContextStr);
          userContext.roleName = _self.userRole; // Add or update role
          localStorage.setItem(
            keySuffix + 'userContext',
            JSON.stringify(userContext),
          );
        } catch (e) {
          console.error('Failed to update userContext:', e);
        }
        if (callback) {
          callback();
        }
      }
    });
  }

  isActive(menuItem: any): boolean {
    // Check if the current URL matches the menu item's URL
    return menuItem.url ? this.router.url === `/${menuItem.url}` : false;
  }

  public applicationData: any = {};

  /**
   * Get Application Details
   */
  getApplicationDetails(id: any) {
    var _self = this;
    if (!id) {
      return;
    }

    let url =
      _self.locator.config.get('endpoint.application') +
      '/public/applicationDetails/' +
      id;
    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form.message = !res.success;
      _self.form.message = res.result['message'];

      if (res.success) {
        _self.applicationData = res.result.data;
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        if (
          res.result.data['logo'] != null &&
          res.result.data['logo'] !== undefined
        ) {
          localStorage.setItem(
            keySuffix + 'appLogoId',
            res.result.data['logo'],
          );
          _self.applicationData = res.result.data;
        }
      }
    });
  }

  ngAfterViewInit() {
    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    const sidebar = document.querySelector('.sidebar-nav') as HTMLElement;
    if (window.innerWidth < 768) {
      if (sidebar) {
        sidebar.style.fontSize = '14px';
        sidebar.style.overflowX = 'auto';
      }
    } else {
      if (sidebar) {
        sidebar.style.fontSize = 'inherit';
        sidebar.style.overflowX = 'visible';
      }
    }
  }

  inputSearch(event: Event) {
    const searchQuery = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    this.menuSearch(searchQuery);
    this.reportSearch(searchQuery);
    this.urlSearch(searchQuery);
  }

  reportSearch(searchQuery: any) {
    if (!searchQuery) {
      this.reportlist = [
        ...this.reportData?.map((item: any) => ({
          title: item.name,
          Id: item.reportsId,
        })),
      ];
    } else {
      this.reportlist = [
        ...this.reportData
          ?.map((item: any) => ({
            title: item.name,
            Id: item.reportsId,
            score: this.getMatchScore(item.name, searchQuery),
          }))
          .filter((item: any) => item.score > 0)
          .sort((a: any, b: any) => {
            if (b.score !== a.score) {
              return b.score - a.score;
            }
            return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
          }),
      ];
    }
  }

  menuSearch(searchQuery: any) {
    if (!searchQuery) {
      this.menulist = [
        ...this.menuData?.map((item: any) => ({
          title: item.name,
          Id: item.formId,
        })),
      ];
    } else {
      this.menulist = [
        ...this.menuData
          ?.map((item: any) => ({
            title: item.name,
            Id: item.formId,
            score: this.getMatchScore(item.name, searchQuery),
          }))
          .filter((item: any) => item.score > 0)
          .sort((a: any, b: any) => {
            if (b.score !== a.score) {
              return b.score - a.score;
            }
            return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
          }),
      ];
    }
  }

  urlSearch(searchQuery: any) {
    if (!searchQuery) {
      this.urlList = [
        ...this.urlData?.map((item: any) => ({
          title: item.name,
          Id: item.url,
        })),
      ];
    } else {
      this.urlList = [
        ...this.urlData
          ?.map((item: any) => ({
            title: item.name,
            Id: item.url,
            score: this.getMatchScore(item.name, searchQuery),
          }))
          .filter((item: any) => item.score > 0)
          .sort((a: any, b: any) => {
            if (b.score !== a.score) {
              return b.score - a.score;
            }
            return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
          }),
      ];
    }
  }

  getMatchScore(item: string, query: string): number {
    if (item && query) {
      const lowerCaseItem = item.toLowerCase();
      const lowerCaseQuery = query.toLowerCase();
      const matchPosition = lowerCaseItem.indexOf(lowerCaseQuery);
      if (matchPosition === -1) return 0;
      return 100 - matchPosition;
    }
    return 0;
  }

  clearInputContant() {
    this.inputsearchcontant = '';
    this.menulist = [
      ...this.menuData?.map((item: any) => ({
        title: item.name,
        Id: item.formId,
      })),
    ];

    this.reportlist = [
      ...this.reportData?.map((item: any) => ({
        title: item.name,
        Id: item.reportsId,
      })),
    ];

    this.urlList = [
      ...this.urlData?.map((item: any) => ({
        title: item.name,
        Id: item.url,
      })),
    ];
  }

  public isTheme: any = (() => {
    const keySuffix = localStorage.getItem('keySuffix');
    if (!keySuffix) return 'lightmode';
    const theme = localStorage.getItem(keySuffix + 'theme');
    return theme || 'lightmode';
  })();

  subscribeToData() {
    this.sharedata.getData().subscribe({
      next: (data: any) => {
        this.isTheme = data['data'] || 'lightmode';
      },
      error: (err) => console.error('Error:', err),
    });
  }

  toggleDarkMode = (theme: any) => {
    const currentUrl = this.router.url;
    const isAuthPage = [
      '/login',
      '/signup',
      '/forgotpassword',
      '/signupInvitation',
    ].some((path) => currentUrl.includes(path));
    if (isAuthPage) return; // ← do not apply theme on auth pages

    let keySuffixContext = localStorage.getItem('keySuffix');
    let sidebarColor = localStorage.getItem(
      keySuffixContext + 'selectedSidebarColor',
    );
    if (theme && sidebarColor == null) {
      localStorage.removeItem(keySuffixContext + 'selectedSidebarColor');
      if (theme === 'darkmode') {
        document.documentElement.setAttribute('class', 'dark-theme');
        document.documentElement.style.setProperty(
          '--primary-color',
          '#12181a',
        );
        document.documentElement.style.setProperty(
          '--secondary-color',
          '#f1f1f1',
        );
      } else if (theme == 'lightmode') {
        document.documentElement.setAttribute('class', 'light-theme');
        document.documentElement.style.setProperty('--primary-color', '#fff');
        document.documentElement.style.setProperty(
          '--secondary-color',
          '#5f5f5f',
        );
      } else if (theme == 'semidark') {
        document.body.classList.remove('light-theme');
        document.documentElement.setAttribute('class', 'semi-dark');
        document.documentElement.style.setProperty('--primary-color', '#fff');
        document.documentElement.style.setProperty(
          '--secondary-color',
          '#5f5f5f',
        );
      }
    }

    if (keySuffixContext)
      localStorage.setItem(keySuffixContext + 'theme', theme);
  };

  toggleDarkModeFun() {
    localStorage.removeItem(this.keySuffixContext + 'selectedSidebarColor');
    this.isTheme = localStorage.getItem(this.keySuffixContext + 'theme');
    if (this.isTheme === 'lightmode') {
      localStorage.setItem(this.keySuffixContext + 'theme', 'darkmode');
      this.toggleDarkMode('darkmode');
      this.sharedata.sendData('darkmode');
    } else if (this.isTheme === 'darkmode') {
      localStorage.setItem(this.keySuffixContext + 'theme', 'lightmode');
      this.toggleDarkMode('lightmode');
      this.sharedata.sendData('lightmode');
    } else {
      localStorage.setItem(this.keySuffixContext + 'theme', 'lightmode');
      this.toggleDarkMode('lightmode');
      this.sharedata.sendData('lightmode');
    }
  }

  isBackToTopVisible = false;
  isPageLoading = false;
  loaderProgress = 0;
  loadingMessage = 'Loading';
  private isLoggingOut = false;

  // Listen to scroll events
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isBackToTopVisible = window.scrollY > 300;
  }

  // Scroll to top method
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  menuData: any[] = [];
  reportData: any[] = [];
  urlData: any[] = [];

  getMenuReportAndUrl(menus: any) {
    menus?.forEach((data: any) => {
      if (data) {
        // Check if data is already in menuData (based on formId)
        if (
          data.linkto === 'form' &&
          !this.menuData.some((item) => item.formId === data.formId)
        ) {
          this.menuData.push(data);
        }
        // Check if data is already in reportData (based on reportsId)
        else if (
          data.linkto === 'report' &&
          !this.reportData.some((item) => item.reportsId === data.reportsId)
        ) {
          this.reportData.push(data);
        }
        // Check if data is already in urlData (based on code)
        else if (
          data.linkto === 'url' &&
          !this.urlData.some((item) => item.code === data.code)
        ) {
          this.urlData.push(data);
        }
      }

      // Recursive call for children
      if (data.children && data.children?.length > 0) {
        this.getMenuReportAndUrl(data.children);
      }
    });
  }

  profileName() {
    this.sharedata.getSharedData().subscribe({
      next: (data) => {
        //  this.userContext['name'] = data['name'];
        console.log(data['name'], "data['name']");
        if (data['name']) {
          this.userContext['name'] = data['name'];

          let keySuffix = localStorage.getItem('keySuffix');
          let storedUserContext = keySuffix
            ? localStorage.getItem(keySuffix + 'userContext')
            : null;

          // Parse stored data or fallback to empty object
          let existingUserContext = storedUserContext
            ? JSON.parse(storedUserContext)
            : {};

          // Merge existing userContext with new imageId
          this.userContext = {
            ...existingUserContext, // Spread existing values
            name: data['name'], // Update only imageId
          };

          // Save updated userContext back to local storage
          if (keySuffix) {
            localStorage.setItem(
              keySuffix + 'userContext',
              JSON.stringify(this.userContext),
            );
          }
        }
      },
      error: (err) => console.error('Error:', err),
    });
  }

  updateProfile() {
    this.sharedata.getSharedData().subscribe({
      next: (data) => {
        if (data && data['imageId'] !== undefined && data['imageId'] !== null) {
          let keySuffix = localStorage.getItem('keySuffix');
          let storedUserContext = keySuffix
            ? localStorage.getItem(keySuffix + 'userContext')
            : null;

          // Parse stored data or fallback to empty object
          let existingUserContext = storedUserContext
            ? JSON.parse(storedUserContext)
            : {};

          // Merge existing userContext with new imageId
          this.userContext = {
            ...existingUserContext,
            imageId: data['imageId'],
          };

          // Save updated userContext back to local storage
          if (keySuffix) {
            localStorage.setItem(
              keySuffix + 'userContext',
              JSON.stringify(this.userContext),
            );
          }
        }
      },
      error: (err) => {
        console.error('❌ [DEBUG] Error in shared data subscription:', err);
      },
    });
  }

  clearInputSearch() {
    setTimeout(() => {
      this.inputsearchcontant = '';
    }, 300);
  }

  switchLanguage(language: string): void {
    this.translate.use(language);
    localStorage.setItem('userLanguage', language);
    this.currentLang = language;
  }

  getApplicationRoles() {
    const url =
      this.locator.config.get('endpoint.application.role') +
      '/get/' +
      this.applicationRoleId;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        console.error('Server Error:', error);
        return;
      }

      let data = res.result?.data || [];
      this.accessList = data?.accessList || [];

      localStorage.setItem(
        this.keySuffixContext + 'accessList',
        JSON.stringify(this.accessList),
      );
    });
  }
  get isSidebarColored(): boolean {
    return document.documentElement.classList.contains('color-sidebar');
  }
}